import { render, staticRenderFns } from "./RelativeMessages.vue?vue&type=template&id=73bef7dc"
import script from "./RelativeMessages.vue?vue&type=script&lang=js"
export * from "./RelativeMessages.vue?vue&type=script&lang=js"
import style0 from "./RelativeMessages.vue?vue&type=style&index=0&id=73bef7dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports